import { Column } from "../../../Components/Tables/Table";
import { ASN } from "./asnOverview.model";

export class createAsn {
  public supplier: any;
  public warehouse: any;
  public reference1: string;
  public reference2: string;
  public contactName: string;
  public contactNumber: string;
  public tracking: string;
  public expectedDate: string;
  public carrierName: any;
  public specialInstruction: string;
  constructor() {
    this.supplier = "";
    this.warehouse = "";
    this.reference1 = "";
    this.reference2 = "";
    this.contactName = "";
    this.contactNumber = "";
    this.tracking = "";
    this.expectedDate = "";
    this.carrierName = "";
    this.specialInstruction = "";
  }
}

export interface AsnDetailProps {
  columns: Column[];
  InboundASNOverviewData: any;
  data: any;
  setData: React.Dispatch<React.SetStateAction<ASN | null>>;
  showViewModal: boolean;
  setViewModal: React.Dispatch<React.SetStateAction<boolean>>;
  screenName: string;
  addUrl: string;
  listUrl: string;
  isHistoryEnabled: boolean;
  noOfrowsToDisplay: number;
}